import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducers from '../reducers';
import rootSaga from '../sagas';



// The top-level state object
//export interface ApplicationState {
//    counter: Counter.CounterState | undefined;
//    weatherForecasts: WeatherForecasts.WeatherForecastsState | undefined;
//}

//// Whenever an action is dispatched, Redux will update each top-level application state property using
//// the reducer with the matching name. It's important that the names match exactly, and that the reducer
//// acts on the corresponding ApplicationState property type.
//export const reducers_old = {
//    counter: Counter.reducer,
//    weatherForecasts: WeatherForecasts.reducer
//};

//// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
//// correctly typed to match your store.
//export interface AppThunkAction<TAction> {
//    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
//}


const sagaMiddleware = createSagaMiddleware();

const store = createStore(reducers, composeWithDevTools(applyMiddleware(sagaMiddleware)));

sagaMiddleware.run(rootSaga);

export default store;